import { Suspense, lazy } from "react";

import { Route } from "react-router-dom";

import type { IApp } from "shared/types";

const EmailConfirmationCodePage = lazy(() => import("./Pages/EmailConfirmationCode"));

import { routes } from "./constants";

class AuthApp implements IApp {
	getRoutes = () => [
		<Route key="auth-routes">
			<Route
				key={routes.en.getPath()}
				path={routes.en.getElementKey()}
				element={
					<Suspense>
						<EmailConfirmationCodePage />
					</Suspense>
				}
			/>
		</Route>
	];
}

export default AuthApp;
